import sports from '@scoutgg/scoring-rules/sports';
const positions = Object.values(sports)
  .flatMap(sport => Object.values(sport).flatMap(v => v.positions) || [])
  .reduce((set, pos) => set.add(pos || 'player'), new Set())
positions.add('chaff')
positions.add('outsider')

function getSportPositions(sport) {
  if(!sport) return Array.from(positions)
  return Object.values(sports[sport]).flatMap(v => v.positions)
    .filter(a => a)
}

const type = String
const enumValues = Array.from(positions)

// CommonJS export
export default {
  type,
  enumValues,
  getSportPositions
};

// ESM export for client builds - this will be handled by the build process
export {getSportPositions};

export {type};
export {enumValues};
